import React, { useState, useEffect } from 'react'
import { getFunctions, httpsCallable } from 'firebase/functions'
import { app } from '../firebase'
import BlockedPage from '../components/BlockedPage'
import LoadingSpinner from '../components/LoadingSpinner'

const RegionCheck = ({ children }) => {
	const [isAllowed, setIsAllowed] = useState(null) // null = checking, true = allowed, false = blocked
	const [isLoading, setIsLoading] = useState(true)

	useEffect(() => {
		checkUserRegion()
	}, [])

	const checkUserRegion = async () => {
		try {
			const functions = getFunctions(app, 'europe-west1')
			const checkRegion = httpsCallable(functions, 'checkRegion')

			const result = await checkRegion()

			console.log('Region check result:', result.data)

			// If allowed is true or country is null (local dev), allow access
			if (result.data.allowed) {
				setIsAllowed(true)
			} else {
				setIsAllowed(false)
			}
		} catch (error) {
			console.error('Error checking region:', error)
			// In case of error, allow access (fail open for better UX)
			// You can change this to setIsAllowed(false) to fail closed
			setIsAllowed(true)
		} finally {
			setIsLoading(false)
		}
	}

	if (isLoading) {
		return (
			<div
				style={{
					minHeight: '100vh',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					background: '#1a1a1a',
				}}
			>
				<LoadingSpinner width="60px" height="60px" />
			</div>
		)
	}

	if (isAllowed === false) {
		return <BlockedPage />
	}

	return <>{children}</>
}

export default RegionCheck
